const WB_MALPRACTICE_COMPLAINT_TYPES = ["whistleblower", "malpractice"];
export const assesIsWbMalpracticeMode = (caseType) => WB_MALPRACTICE_COMPLAINT_TYPES.some(typeId => typeId === caseType);
